export enum ETargetAccountType {
  INTERNAL_CARD = 'INTERNAL_CARD',
  INTERNATIONAL = 'INTERNATIONAL'
}